const _ = require('lodash');

module.exports = function (shopLocatorService, moveFocus, $rootScope, $timeout, featureService, $state, $templateCache, storePickerService, storePickerPanelService, breakpointsService) {
    return {
        restrict: 'E',
        transclude: {
            title: '?locatorTitle'
        },
        scope: {
            searchInputId: '@?',
            storeSelected: '&',
            isDelivery: '=',
            setSelectedValue: '=?',
            fullfillmentOptions: '=?',
            isAddingNewAddress: '=?',
            addressStoreLocatorSearch: '=?',
            searchStores: '&',
            onClear: '&',
            searchUiOnly: '<?',
            isRequired: '<?',
            locationData: '<?'
        },
        template: require('./shop-locator-search-template.html').trim(),
        link(scope, element) {
            const storeUrlsEnabled = featureService.isEnabled(featureService.features.storeUrls);
            let initSearchTerm = '';

            scope.autocompleteInputId = scope.searchInputId || 'shopLocatorSearch';
            scope.searchTerm = '';
            scope.autocompleteResults = [];
            scope.noResultsMessage = '';
            scope.showNoResultsMessage = false;
            scope.viewMode = { mode: scope.setSelectedValue || false };
            scope.storeType = {
                supermarket: 'supermarket',
                others: 'others'
            };
            scope.autoCompleteMinLength = 2;
            scope.shopLocatorService = shopLocatorService;
            scope.selectedStore = {};
            scope.selectedStoreType = scope.storeType.supermarket;

            // add the autocomplete templates to the templateCache
            $templateCache.put('shopLocatorSuburb', require('./shop-locator-search-suburb-template.html'));
            $templateCache.put('shopLocatorPostcode', require('./shop-locator-search-postcode-template.html'));

            scope.clearInput = function () {
                if (storePickerPanelService.fullfillmentOptions.disableFullfillmentOptions !== undefined) {
                    storePickerPanelService.fullfillmentOptions.disableFullfillmentOptions = true;
                }
                if (scope.onClear) {
                  scope.onClear();
                }

                if (scope.autocompleteResults && scope.autocompleteResults.length) {
                    scope.autocompleteResults = [];
                }

                $timeout(function () {
                    scope.showNoResultsMessage = false;
                });
            };

            function formateSearchTerm(opt) {
                const option = opt || {};
                const {
                    addressData,
                    includeState = true
                } = option;

                let ret = '';

                if (addressData) {
                    const suburb = addressData.SuburbName || addressData.suburb || '';
                    const state = addressData.State || addressData.state || '';
                    const postcode = addressData.PostCode || addressData.postcode || '';

                    if (suburb && postcode) {
                        ret = `${suburb}, ${includeState ? state : ''} ${postcode}`.trim();
                    }
                }

                return ret;
            }

            function setNoResultsMessage(messageType) {
                scope.autocompleteResults = [];

                if (messageType === 'postcode') {
                    scope.noResultsMessage = 'There are no matching postcodes';
                } else if (messageType === 'suburb') {
                    scope.noResultsMessage = 'There are no matching suburbs';
                } else {
                    scope.noResultsMessage = '';
                }
                scope.showNoResultsMessage = true;
            }

            function setAutoCompleteResult(data) {
                const searchInputSelector = '#' + scope.autocompleteInputId;
                scope.autocompleteResults = data;
                element.find(searchInputSelector).focus();
                scope.showNoResultsMessage = false;
            }

            function showAutoCompleteResponse(data, messageType) {
                if (data && data.length === 0) {
                    setNoResultsMessage(messageType);

                    if (scope.searchUiOnly) {
                        scope.$emit('noResults', true);
                    }
                } else {
                    setAutoCompleteResult(data);
                }
            }

            scope.search = function (fnCallback) {
                //Don't run if searchterm is short
                if (scope.searchTerm.length < 2 || scope.shouldNotRepeatSearch) {
                    scope.shouldNotRepeatSearch = false;

                    if (_.isFunction(fnCallback)) {
                        fnCallback();
                    }

                    return;
                }

                scope.template = 'shopLocatorSuburb';

                if (scope.selectedStoreType === scope.storeType.supermarket) {
                    shopLocatorService
                        .searchSuburbs(scope.searchTerm)
                        .then((data) => {
                            showAutoCompleteResponse(data, 'suburb');

                            if (_.isFunction(fnCallback)) {
                                fnCallback();
                            }
                        });
                }
            };

            scope.populateAutocompleteList = function (fnCallback) {
                scope.showNoResultsMessage = false;

                if (scope.searchTerm && scope.searchTerm.length > scope.autoCompleteMinLength) {
                    if (initSearchTerm !== scope.searchTerm) {
                        scope.search(fnCallback);
                    }
                }
            };

            scope.onSelect = function (option) {
                if (scope.isAddingNewAddress && option) {
                    scope.addressStoreLocatorSearch.suburb = option.SuburbName;
                    scope.addressStoreLocatorSearch.postcode = option.PostCode;
                    scope.addressStoreLocatorSearch.state = option.State;
                }

                if (!option) {
                    return;
                }

                //If Fulfilment method popup, populate the input with the search term
                if (scope.setSelectedValue) {
                    storePickerPanelService.fullfillmentOptions.disableFullfillmentOptions = false;
                    scope.searchTerm = formateSearchTerm({
                        addressData: option,
                        includeState: false
                    });
                    storePickerService.store = option;
                    scope.shouldNotRepeatSearch = true;

                    moveFocus('.store-picker-panel_radios');

                    scope.searchStores();
                    if (storePickerPanelService.changeStoreView) {
                        storePickerPanelService.deliverySearch = option;
                    }

                } else {
                    scope.searchTerm = formateSearchTerm({ addressData: option });
                    scope.shouldNotRepeatSearch = true;
                    if (storePickerPanelService.fullfillmentOptions.disableFullfillmentOptions !== undefined) {
                        storePickerPanelService.fullfillmentOptions.disableFullfillmentOptions = true;
                    }
                }

                scope.hasSelectedStore(option);
                
                if (scope.searchUiOnly) {
                    scope.$emit('noResults', false);
                }
            };

            scope.hasSelectedStore = function (store) {
                scope.selectedStore = store;
                scope.storeSelected({ store });
            };

            scope.toggleStoreType = function (type) {
                if (scope.selectedStoreType !== type) {
                    scope.searchTerm = '';
                    scope.autocompleteResults = [];
                }
                scope.selectedStoreType = type;
            };

            scope.closeDetails = function () {
                scope.searchTerm = '';
                scope.autocompleteResults = [];
                scope.selectedStore = null;
                $rootScope.$broadcast('storeLocator:detailsClose');
            };

            scope.onSearchFocus = function () {
                const scrollElm = breakpointsService.getScrollElement();
                const searchInputSelector = '#' + scope.autocompleteInputId;
                scrollElm.animate({ scrollTop: $(searchInputSelector).offset().top - breakpointsService.getScrollOffset() }, 300);
            };

            function validateStoreInfo(storeInfo) {
                if (storeInfo && storeInfo.storeNo) {
                    shopLocatorService.getStore(storeInfo.storeNo).then(function (store) {
                        if (shopLocatorService.urlParametersValid(store, storeInfo)) {
                            scope.hasSelectedStore(store);
                        } else {
                         //   $state.go('shop.404error');
                        }
                    });
                } else {
                    // $state.go('shop.404error');
                }
            }

            // only watch if NOT use as searchUiOnly
            if (!scope.searchUiOnly) {
                scope.$watch(function () {
                    return $state.params.store;
                }, function (newStore, oldStore) {

                    if (newStore && oldStore !== newStore && storeUrlsEnabled) {
                        const storeParam = shopLocatorService.getStoreInfoFromUrlParams($state.params.store);

                        //if current URL is not the same as the selected store from the service, select store from URL.
                        if (shopLocatorService.selectedStore === undefined || storeParam.storeNo !== parseInt(shopLocatorService.selectedStore.StoreNo, 10)) {
                            validateStoreInfo(storeParam);
                        }
                    } else if (newStore === undefined && oldStore && $state.is('shop.locator') && shopLocatorService.selectedStore !== undefined) {
                        //if a store was previously selected but has not yet been closed, close the store details.
                        scope.closeDetails();
                    }
                });

                if (shopLocatorService.selectedStore && storeUrlsEnabled) {
                    scope.selectedStore = shopLocatorService.selectedStore;
                    scope.storeSelected(shopLocatorService.selectedStore);
                } else {
                    scope.selectedStore = null;
                }
            }


            if (scope.searchUiOnly) {
                const locationDataOneTimeWatch = scope.$watch('locationData', function (newValue, oldValue) {
                    if (newValue && newValue !== oldValue) {
                        initSearchTerm = formateSearchTerm({ addressData: newValue });
                        scope.searchTerm = initSearchTerm;
                        locationDataOneTimeWatch();
                    }
                }, true);

                scope.$on('validateLocation', function(event, currentSearchTerm) {
                    // after user logged-in, locationData(optional scope) will be populated by one-way binding
                    // scope.addressStoreLocatorSearch will be empty
                    // if user then change the address. use addressStoreLocatorSearch for validation
                    const matchingLocationData = !scope.addressStoreLocatorSearch.suburb
                        ? scope.locationData
                        : scope.addressStoreLocatorSearch;

                    const formattedSearchTerm = formateSearchTerm({ addressData: matchingLocationData });

                    if (currentSearchTerm === formattedSearchTerm) {
                        // populate scope.addressStoreLocatorSearch if it is empty
                        if (!scope.addressStoreLocatorSearch.suburb && scope.isAddingNewAddress) {
                            scope.addressStoreLocatorSearch.suburb = matchingLocationData.suburb;
                            scope.addressStoreLocatorSearch.postcode = matchingLocationData.postcode;
                            scope.addressStoreLocatorSearch.state = matchingLocationData.state;
                        }
                        return;
                    }

                    setNoResultsMessage('suburb');
                });
            }
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/shoplocator/shop-locator-search-directive.js
 **/